import { render, staticRenderFns } from "./EPFSetupGrid.vue?vue&type=template&id=725900f6"
import script from "./EPFSetupGrid.vue?vue&type=script&lang=js"
export * from "./EPFSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports